import * as constants from './constants'

const waitingListState = {
    waitingListState: null,
    isSubscribed: null,
    waitingListStateError: null,
    waitingListId: null,
}

export const reducer = (state = waitingListState, action) => {
    switch (action.type) {
        case constants.SET_WAITING_LIST_STATE: {
            return { ...state, waitingListState: action.data }
        }
        case constants.GET_WAITING_LIST_STATE_ERROR: {
            return { ...state, waitingListStateError: action.data }
        }
        case constants.SUCCESS_SUBSCRIBE_WAITING_LIST: {
            return { ...state, isSubscribed: action.data }
        }
        case constants.SET_WAITLIST_ID: {
            return { ...state, waitingListId: action.data }
        }
        case constants.CLEAR_WAITLIST_ERROR_STATE: {
            return { ...state, waitingListStateError: null }
        }
        case constants.CLEAR_WAITLIST_STATE: {
            return { ...state, waitingListState: null }
        }
        default:
            return state
    }
}
